import { useEffect, useState, FC } from 'react';
import { Select, MenuItem, SelectChangeEvent, Box } from '@mui/material';
import i18n from '../../../../i18n';
import RussiaFlag from '../../../../assets/images/icons/flags/ru.svg';
import USFlag from '../../../../assets/images/icons/flags/us.svg';
import styles from './language-toggle.module.sass';

const languages = [
  { code: 'ru', label: 'Рус', Flag: RussiaFlag },
  { code: 'en', label: 'Eng', Flag: USFlag },
] as const;

type LanguageCode = (typeof languages)[number]['code'];

const LanguageToggle: FC = () => {
  const [currentLang, setCurrentLang] = useState<LanguageCode>(
    (i18n.language as LanguageCode) || 'ru',
  );

  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      setCurrentLang(lng as LanguageCode);
    };
    i18n.on('languageChanged', handleLanguageChanged);
    return () => i18n.off('languageChanged', handleLanguageChanged);
  }, []);

  const handleChange = (e: SelectChangeEvent<LanguageCode>) => {
    const lang = e.target.value as LanguageCode;
    i18n.changeLanguage(lang);
  };

  return (
    <Select
      value={currentLang}
      onChange={handleChange}
      variant="standard"
      size="small"
      disableUnderline={false}
      sx={{
        color: '#8586A5',
        '& .MuiSelect-select': {
          display: 'flex',
          alignItems: 'center',
          paddingBottom: '0px',
          paddingTop: '0px',
          paddingY: '2px',
          minHeight: 'auto',
        },

        '& .MuiSelect-icon': {
          color: '#8586A5',
        },
        '&::before': {
          borderBottom: 'none',
        },
        '&:hover:not(.Mui-disabled, .Mui-error):before': {
          borderBottom: '1px solid #8586A5',
        },
        '&.Mui-focused:before': {
          borderBottom: '1px solid #8586A5',
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            bgcolor: ' #1A2235',
            color: 'white',
          },
        },
      }}
    >
      {languages.map(({ code, label, Flag }) => (
        <MenuItem key={code} value={code}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'baseline',
              gap: 1,
              paddingBottom: 0,
              marginBottom: 0,
            }}
          >
            <img src={Flag} alt={`${label} flag`} width={20} height={15} />
            <span className={styles.hideLabel}>{label}</span>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageToggle;
